import React, { useState, useContext, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { SwipeableDrawer, createStyles, makeStyles, Grid,
	 Typography, Avatar, MenuList, MenuItem, Button,
	 ListItemIcon, ListItemText, ListSubheader, IconButton,
	 FormControl, Select } from '@material-ui/core';
import { Work, GroupAdd, People, Menu } from '@material-ui/icons';
import firebase from '../Firebase.js';
import { AuthContext } from '../contexts/AuthContext.js';
import { languageOptions } from '../i18n.js';

const useStyles = makeStyles(
  (theme) =>
    createStyles({
      signOutBtn: {
	borderRadius: 25,
	color: theme.palette.primary.main,
	background: theme.palette.primary.red,
	marginTop:  theme.spacing(1),
	'&:hover': {
	  background: theme.palette.primary.red,
	},
      },
      avatar: {
	width: 60,
	height: 60,
      },
      profileBox: {
	background: theme.palette.primary.green,
	padding: theme.spacing(2),
      },
      uiLanguage: {
	paddingLeft: theme.spacing(2),
	paddingRight: theme.spacing(2),
      },
      editProfileLink: {
	color: 'black',
      },
      editProfileBtn: {
	borderRadius: 15,
	background: theme.palette.primary.yellow,
	'&:hover': {
	  background: theme.palette.primary.yellow,
	},
      },
    }),
);

const EditProfileBtn = withRouter(
  ({ history, closeMenu }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    return (
      <Button size='small'
	      className={classes.editProfileBtn}
	      onClick={() => {
		closeMenu();
		history.push('/profile');
	      }} >
	{t('edit-profile')}
      </Button>
    );
  }
);

const SignoutBtn = withRouter(
  ({ history, closeMenu }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
      <Button label='sign-out'
	      size='small'
	      onClick={async () => {
		closeMenu();
		await firebase.auth().signOut();
		history.push('/login');
	      }}
	      variant='contained' className={classes.signOutBtn}>
	{t('sign-out')}
      </Button>
    );
  }
);


export default withRouter(({history}) => {

  const classes = useStyles();

  const { t, i18n } = useTranslation();
  const { isAuthAdmin, authUser } = useContext(AuthContext);
  const [ language, setLanguage ] = useState(authUser.uiLang);
  const [ open, setOpen ] = useState(false);
  const openMenu = _ => setOpen(true);
  const closeMenu = _ => setOpen(false);

  const changeUiLang = async (selectedLang) => {
    setLanguage(selectedLang);
    i18n.changeLanguage(selectedLang);
    firebase.firestore().collection('trainers').doc(authUser.email)
      .collection('profile').doc('details').set({uiLang: selectedLang}, {merge: true});
  };

  const activeStyle = (path) => {
    return history.location.pathname === path ? { background: '#F5F5F5' } : {};
  };

  return (
    <Fragment>
      <IconButton
	color='inherit'
	aria-label='open drawer'
	onClick={openMenu}
	className={classes.menuButton}>
	<Menu />
      </IconButton>

      <SwipeableDrawer
	disableDiscovery
	open={open}
	onClose={closeMenu}
	onOpen={openMenu}>
	<Grid container alignItems='center' className={classes.profileBox} spacing={2}>
	  <Grid item xs={4}>
	    <Avatar alt='avatar' src={authUser.photoURL} className={classes.avatar} />
	  </Grid>
	  <Grid container item xs={8} direction='column'>
	    <Typography variant='subtitle2'> { authUser.name || 'No name'} </Typography>
	    <Typography gutterBottom variant='subtitle2'> { authUser.email } </Typography>
	    <Typography gutterBottom>
	      <EditProfileBtn closeMenu={closeMenu}/>
	    </Typography>
	    <SignoutBtn closeMenu={closeMenu}/>
	  </Grid>
	</Grid>
	<MenuList>
	  <MenuItem component={ Link } to='/' onClick={closeMenu} style={activeStyle('/')}>
	    <ListItemIcon>
	      <Work />
	    </ListItemIcon>
	    <ListItemText primary={ t('pending-exams') } />
	  </MenuItem>
	  <MenuItem component={ Link } to='/finished' onClick={closeMenu} style={activeStyle('/finished')}>
	    <ListItemIcon>
	      <Work />
	    </ListItemIcon>
	    <ListItemText primary={ t('my-finished-exams') } />
	  </MenuItem>
	  <MenuItem component={ Link } to='/clients' onClick={closeMenu} style={activeStyle('/clients')}>
	    <ListItemIcon>
	      <People />
	    </ListItemIcon>
	    <ListItemText primary={ t('clients') } />
	  </MenuItem>
	  {
	    isAuthAdmin() &&
	      <MenuItem component={ Link } to='/trainers' onClick={closeMenu} style={activeStyle('/trainers')}>
		<ListItemIcon>
		  <GroupAdd />
		</ListItemIcon>
		<ListItemText primary={ t('trainers') } />
	      </MenuItem>
	  }
	  {
	    isAuthAdmin() &&
	      <MenuItem component={ Link } to='/admins' onClick={closeMenu} style={activeStyle('/admins')}>
		<ListItemIcon>
		  <GroupAdd />
		</ListItemIcon>
		<ListItemText primary={ t('admins') } />
	      </MenuItem>
	  }
	</MenuList>
	
	<ListSubheader component='div' id='nested-list-subheader'> 
		{t('exams-reviewed')} : { authUser.numberOfReviews } 
	</ListSubheader>
	<ListSubheader component='div' id='nested-list-subheader'>
	  { t('choose-ui-language') }
	</ListSubheader>
	<FormControl className={classes.uiLanguage}>
	  <Select
	    value={language}
	    onChange={(e) => changeUiLang(e.target.value)}>
	    {languageOptions.map((lang) => {
	      return (<MenuItem key={ lang.key } value={ lang.key }> { lang.label }</MenuItem>);
	    })}
	  </Select>
	</FormControl>
	<ListSubheader component='div' id='nested-list-subheader'>
	  {t('version') + ' 0.241'}
	</ListSubheader>
      </SwipeableDrawer>
    </Fragment>
  );
});
